import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 10px;
  flex: 1 1;
  z-index: 101;
  &:first-of-type {
    margin-left: 0;
  }
`;
